import clsx from 'clsx';

import { getAssetUrl } from '@utils/getAssetUrl';

export interface TipProps {
  text: string;
  isTutorial?: boolean;
}
const Tip = ({ text, isTutorial = false }: TipProps) => (
  <div
    className={clsx(
      'absolute',
      isTutorial
        ? '-right-24 bottom-[calc(-100%-10px)]'
        : 'bottom-[calc(-100%+95px)] right-0 md:inset-y-0 md:right-0',
    )}
  >
    <img
      src={getAssetUrl('images/girl-tip.png')}
      alt="Zamyšlená dívka"
      title="Zamyšlená dívka"
      className={clsx(
        'relative min-w-[420px]',
        isTutorial
          ? '-top-8 right-[-80px]'
          : 'right-[-172px] md:-top-8 md:right-[-80px]',
      )}
    />
    <div
      className={clsx(
        'absolute',
        isTutorial
          ? 'right-[228px] top-[14px]'
          : 'right-[136px] top-[54px] md:right-[228px] md:top-[14px]',
      )}
    >
      <div className="absolute right-[-38px] top-[-6px] h-[13px] w-[13px] rounded-full bg-brand-primary-400"></div>
      <div className="absolute right-[-17px] top-[-2px] h-[18px] w-[18px] rounded-full bg-brand-primary-400"></div>
      <div
        className={clsx(
          'flex items-center justify-center rounded-[64px] bg-brand-primary-400 fill-brand-gray-100 px-6 py-4 text-center font-patrick-hand text-[16px]/[18px] uppercase',
          isTutorial ? 'w-[200px]' : 'w-[170px]',
        )}
      >
        {text}
      </div>
    </div>
  </div>
);

export default Tip;
